import React, { useState } from 'react';
import { AVAILABLE_FILTERS, DEFAULT_PAGE_CONFIGS, PageFilterConfig } from '../../types/filters';
import { CheckIcon, GripVerticalIcon } from 'lucide-react';
export function FilterConfiguration() {
  const [pageConfigs, setPageConfigs] = useState<PageFilterConfig[]>(DEFAULT_PAGE_CONFIGS);
  const [selectedPage, setSelectedPage] = useState<string>('campaigns');
  const currentConfig = pageConfigs.find(p => p.pageId === selectedPage);
  const toggleFilter = (filterId: string) => {
    setPageConfigs(prev => prev.map(config => {
      if (config.pageId === selectedPage) {
        const enabled = config.enabledFilters.includes(filterId);
        return {
          ...config,
          enabledFilters: enabled ? config.enabledFilters.filter(id => id !== filterId) : [...config.enabledFilters, filterId]
        };
      }
      return config;
    }));
  };
  const enableAllFilters = () => {
    setPageConfigs(prev => prev.map(config => {
      if (config.pageId === selectedPage) {
        return {
          ...config,
          enabledFilters: AVAILABLE_FILTERS.map(f => f.id)
        };
      }
      return config;
    }));
  };
  const disableAllFilters = () => {
    setPageConfigs(prev => prev.map(config => {
      if (config.pageId === selectedPage) {
        return {
          ...config,
          enabledFilters: []
        };
      }
      return config;
    }));
  };
  const leadFilters = AVAILABLE_FILTERS.filter(f => f.category === 'lead');
  const callFilters = AVAILABLE_FILTERS.filter(f => f.category === 'call');
  const otherFilters = AVAILABLE_FILTERS.filter(f => f.category === 'other');
  return <div data-id="element-3548">
      <h1 className="text-2xl font-semibold text-gray-800 mb-2" data-id="element-3549">
        Filter Configuration
      </h1>
      <p className="text-gray-600 mb-8" data-id="element-3550">
        Configure which filters are available on each page
      </p>

      <div className="grid grid-cols-4 gap-6" data-id="element-3551">
        {/* Page Selection Sidebar */}
        <div className="col-span-1" data-id="element-3552">
          <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-3553">
            <h3 className="font-medium text-gray-800 mb-4 text-sm" data-id="element-3554">Pages</h3>
            <div className="space-y-1" data-id="element-3555">
              {pageConfigs.map(page => <button key={page.pageId} onClick={() => setSelectedPage(page.pageId)} className={`w-full text-left px-3 py-2 rounded-md text-sm transition-colors ${selectedPage === page.pageId ? 'bg-blue-50 text-blue-600 font-medium' : 'text-gray-700 hover:bg-gray-50'}`} data-id="element-3556">
                  {page.pageName}
                  <span className="text-xs text-gray-500 block mt-0.5" data-id="element-3557">
                    {page.enabledFilters.length} filters
                  </span>
                </button>)}
            </div>
          </div>
        </div>

        {/* Filter Configuration */}
        <div className="col-span-3 space-y-6" data-id="element-3558">
          <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-3559">
            <div className="flex items-center justify-between mb-6" data-id="element-3560">
              <div data-id="element-3561">
                <h2 className="text-lg font-semibold text-gray-800" data-id="element-3562">
                  {currentConfig?.pageName}
                </h2>
                <p className="text-sm text-gray-600" data-id="element-3563">
                  Select which filters to show on this page
                </p>
              </div>
              <div className="flex space-x-2" data-id="element-3564">
                <button onClick={enableAllFilters} className="px-4 py-2 text-sm border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 transition-colors" data-id="element-3565">
                  Enable All
                </button>
                <button onClick={disableAllFilters} className="px-4 py-2 text-sm border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 transition-colors" data-id="element-3566">
                  Disable All
                </button>
              </div>
            </div>

            <div className="grid grid-cols-3 gap-6" data-id="element-3567">
              {/* LEAD Filters */}
              <div data-id="element-3568">
                <h3 className="text-sm font-semibold text-blue-600 mb-3 uppercase tracking-wider" data-id="element-3569">
                  Lead
                </h3>
                <div className="space-y-2" data-id="element-3570">
                  {leadFilters.map(filter => {
                  const isEnabled = currentConfig?.enabledFilters.includes(filter.id);
                  return <button key={filter.id} onClick={() => toggleFilter(filter.id)} className={`w-full flex items-center justify-between px-3 py-2 rounded-md text-sm transition-all ${isEnabled ? 'bg-blue-50 border-2 border-blue-500 text-blue-700' : 'bg-gray-50 border-2 border-transparent text-gray-700 hover:border-gray-300'}`} data-id="element-3571">
                        <span className="flex items-center" data-id="element-3572">
                          <GripVerticalIcon size={14} className="mr-2 text-gray-400" data-id="element-3573" />
                          {filter.label}
                        </span>
                        {isEnabled && <CheckIcon size={16} className="text-blue-600 flex-shrink-0" data-id="element-3574" />}
                      </button>;
                })}
                </div>
              </div>

              {/* CALL Filters */}
              <div data-id="element-3575">
                <h3 className="text-sm font-semibold text-blue-600 mb-3 uppercase tracking-wider" data-id="element-3576">
                  Call
                </h3>
                <div className="space-y-2" data-id="element-3577">
                  {callFilters.map(filter => {
                  const isEnabled = currentConfig?.enabledFilters.includes(filter.id);
                  return <button key={filter.id} onClick={() => toggleFilter(filter.id)} className={`w-full flex items-center justify-between px-3 py-2 rounded-md text-sm transition-all ${isEnabled ? 'bg-blue-50 border-2 border-blue-500 text-blue-700' : 'bg-gray-50 border-2 border-transparent text-gray-700 hover:border-gray-300'}`} data-id="element-3578">
                        <span className="flex items-center" data-id="element-3579">
                          <GripVerticalIcon size={14} className="mr-2 text-gray-400" data-id="element-3580" />
                          {filter.label}
                        </span>
                        {isEnabled && <CheckIcon size={16} className="text-blue-600 flex-shrink-0" data-id="element-3581" />}
                      </button>;
                })}
                </div>
              </div>

              {/* OTHER Filters */}
              <div data-id="element-3582">
                <h3 className="text-sm font-semibold text-blue-600 mb-3 uppercase tracking-wider" data-id="element-3583">
                  Other
                </h3>
                <div className="space-y-2" data-id="element-3584">
                  {otherFilters.map(filter => {
                  const isEnabled = currentConfig?.enabledFilters.includes(filter.id);
                  return <button key={filter.id} onClick={() => toggleFilter(filter.id)} className={`w-full flex items-center justify-between px-3 py-2 rounded-md text-sm transition-all ${isEnabled ? 'bg-blue-50 border-2 border-blue-500 text-blue-700' : 'bg-gray-50 border-2 border-transparent text-gray-700 hover:border-gray-300'}`} data-id="element-3585">
                        <span className="flex items-center" data-id="element-3586">
                          <GripVerticalIcon size={14} className="mr-2 text-gray-400" data-id="element-3587" />
                          {filter.label}
                        </span>
                        {isEnabled && <CheckIcon size={16} className="text-blue-600 flex-shrink-0" data-id="element-3588" />}
                      </button>;
                })}
                </div>
              </div>
            </div>
          </div>

          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4" data-id="element-3589">
            <h4 className="font-medium text-blue-900 mb-2 text-sm" data-id="element-3590">
              How it works
            </h4>
            <ul className="text-sm text-blue-800 space-y-1" data-id="element-3591">
              <li data-id="element-3592">
                • Enabled filters will appear in the header filter bar on the
                selected page
              </li>
              <li data-id="element-3593">• By default, all filters are enabled for all pages</li>
              <li data-id="element-3594">
                • Users can apply filters from the header, and selections
                persist across navigation
              </li>
              <li data-id="element-3595">
                • Click on a filter to enable/disable it for the current page
              </li>
            </ul>
          </div>

          <div className="flex justify-end" data-id="element-3596">
            <button className="px-6 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-colors font-medium" data-id="element-3597">
              Save Configuration
            </button>
          </div>
        </div>
      </div>
    </div>;
}